module.exports = __webpack_public_path__ + "static/lightning-table-expandable-open-d686459885a2ba887578c202de410bcf.png";